<template>
  <div class="flex-none w-72">
    <!-- Date marker (orange) above the card. -->
    <p
      class="text-highlight text-[11px] tracking-wide mb-2 h-4 truncate"
      :class="{ 'opacity-0': !label }"
    >
      <template v-if="label">
        <span class="font-bold uppercase">{{ label.month }}</span
        >{{ label.day }}
        <span class="font-light"> - {{ label.status }}</span>
      </template>
      <template v-else>&nbsp;</template>
    </p>

    <!-- Surface -->
    <div class="flex items-center rounded-lg bg-primary-500 p-3">
      <!-- Poster -->
      <div
        class="h-32 w-24 flex-none rounded-md overflow-hidden bg-primary-400 border border-primary-400"
      >
        <img
          v-if="image"
          :src="image"
          class="h-full w-full object-cover"
          :alt="series.name"
        />
      </div>

      <!-- Meta -->
      <div class="ml-4 min-w-0">
        <p class="text-white text-lg font-semibold leading-tight line-clamp-2">
          {{ series.name }}
        </p>
        <p
          v-if="episode"
          class="text-subtle text-sm tracking-widest mt-2 opacity-80"
        >
          {{ episode }}
        </p>
        <p v-if="series.network" class="text-muted text-xs mt-4">
          {{ $t("dashboard.seeItOn") }}
          <span class="text-white font-semibold">{{ series.network }}</span>
        </p>

        <!-- Vote -->
        <SeriesVote :series="series" class="mt-3" />
      </div>
    </div>
  </div>
</template>

<script>
import { upcomingLabel, episodeLabel, seriesImage } from "@/utils/series";
import SeriesVote from "@/components/series/SeriesVote.vue";

export default {
  name: "PopularUpcomingCard",
  components: { SeriesVote },
  props: {
    series: { required: true },
  },

  computed: {
    image() {
      return seriesImage(this.series, "poster");
    },
    label() {
      return upcomingLabel(this.series);
    },
    episode() {
      return episodeLabel(this.series);
    },
  },
};
</script>
